import React, { Component } from 'react';
import {
  Image,
  ImageBackground,
  Alert,
  Platform,
  ScrollView,
  StyleSheet,
  Text,
  TouchableHighlight,
  Button,
  View,
  ActivityIndicator,
} from 'react-native';

import * as Clipboard from 'expo-clipboard';

import FirebaseConsult from '../firebase/firebase_consult.js'
import FirebaseUsers from '../firebase/firebase_users.js'

import EonnButton from '../components/button';
import TestRequestButton from '../components/test_request_button'; // TEMPORARY
import EonnButton2 from '../components/button2';
import EonnTitle from '../components/title';
import EonnEllipsis from '../components/ellipsis';
import { mstyles } from '../constants/MainStyles';
import common from '../common';


const styles = StyleSheet.create({
  waitingBox: {
    flexDirection:"row",
    maxWidth:200,
    justifyContent:'center',
    alignItems:'center',
    marginTop: 25,
  },
  waitingText: {
    fontSize:20,
    textAlign:'center'
  },
  issueButton: {
    borderBottomColor: '#ceced2',
    borderBottomWidth: 1,
    width: '100%',
  },
  issueButton2: {
    flexDirection: 'row',
    paddingTop: 20,
    paddingRight: 20,
    paddingBottom: 20,
    paddingLeft: 20,
    justifyContent:'space-between',
    alignItems:'center',
  },
  issueName: {
    fontSize: 16,
    lineHeight: 18,
    marginBottom: 4,
  },
  issueTitle: {
    fontSize: 20,
    lineHeight: 21,
  },
  issueVehicle: {
    fontSize: 17,
    lineHeight: 19,
    marginTop: 3,
  },
  profileArrow: {
    marginRight: 5,
    marginLeft: 10,
  },
  statusContainer: {
    flexDirection: 'row',
    width: '100%',
    marginBottom: 40,
    marginTop: 40,
    overflow: 'hidden',
  },
  statusAccent: {
    width: 12,
  },
  statusPendingAccent: {
    backgroundColor: '#e96556',
  },
  statusActionRequiredAccent: {
    backgroundColor: '#e96556',
  },
  statusErrorAccent: {
    backgroundColor: '#e96556',
  },
  statusContent: {
    flex: 1,
    paddingTop: 25,
    paddingBottom: 25,
    paddingLeft: 25,
    paddingRight: 30,
  },
  statusPending: {
    backgroundColor: '#202025',
  },
  statusActionRequired: {
    backgroundColor: '#202025',
  },
  statusError: {
    backgroundColor: '#202025',
  },
  statusTitle: {
    fontSize: 24,
    fontFamily: 'nunito',
    marginBottom: 8,
    color: '#ffffff',
    lineHeight: 24,
  },
  statusMessage: {
    fontSize: 16,
    fontFamily: 'nunito',
    lineHeight: 22,
    color: '#ffffff',
    marginBottom: 12,
    opacity: 0.9,
  },
  statusRow: {
    flexDirection: 'row',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
  },
  retryButtonWrapper: {
    marginTop: 5,
    borderRadius: 40,
    overflow: 'hidden',
    maxWidth: 200,
  },
  retryButton: {
    paddingHorizontal: 24,
    paddingVertical: 12,
    alignItems: 'center',
    justifyContent: 'center',
  },
  retryButtonPending: {
    backgroundColor: '#e96556',
  },
  retryButtonAction: {
    backgroundColor: '#e96556',
  },
  retryButtonText: {
    color: '#ffffff',
    fontSize: 15,
    fontFamily: 'nunito',
    fontWeight: 'bold',
    textTransform: 'uppercase',
    letterSpacing: 0.5,
  },
});

export default class Screen extends Component {

  constructor(props) {
    super(props);
    this.state = {
      issues: [],
      err: "",
      checkingVerification: false,
      copied: false,
      earningsLoading: true,
      earningsLifetime: 0,
      earningsPending: 0,
    };
    this.verificationCheckInterval = null;
  }

  componentDidMount(){
    FirebaseConsult.getIssues( issues => this.updateIssues(issues) );
    FirebaseConsult.watchForIssues( issues => this.updateIssues(issues) );
    
    // Start periodic verification checking if account is pending verification
    this.checkAndStartVerificationPolling();
    this.loadEarningsSummary();
  }

  componentWillUnmount() {
    if (this.verificationCheckInterval) {
      clearInterval(this.verificationCheckInterval);
    }
  }

  loadEarningsSummary = async () => {
    try {
      if (!global.user || !global.user.uid) {
        this.setState({ earningsLoading: false });
        return;
      }
      const r = await fetch('https://us-central1-eonn-teletech.cloudfunctions.net/getTechEarningsSummary', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ techUid: global.user.uid }),
      });
      const data = await r.json();
      this.setState({
        earningsLoading: false,
        earningsLifetime: Math.round((data?.lifetimeNet || 0)) / 100,
        earningsPending: Math.round((data?.pendingNet || 0)) / 100,
      });
    } catch (e) {
      this.setState({ earningsLoading: false });
    }
  }

  checkAndStartVerificationPolling = () => {
    if (global.user && global.user.stripeId && !global.user.stripeLinked) {
      // If user has stripeId but account is not linked, check current status first
      if (global.user.stripeStatus && 
          global.user.stripeStatus.disabled_reason === 'requirements.pending_verification') {
        this.startVerificationPolling();
      } else {
        // Check status once to see if we need to start polling
        this.checkStripeVerification();
      }
    }
  }

  startVerificationPolling = () => {
    // Clear any existing interval
    if (this.verificationCheckInterval) {
      clearInterval(this.verificationCheckInterval);
    }
    
    // Check every 30 seconds
    this.verificationCheckInterval = setInterval(() => {
      this.checkStripeVerification();
    }, 30000);
  }

  stopVerificationPolling = () => {
    if (this.verificationCheckInterval) {
      clearInterval(this.verificationCheckInterval);
      this.verificationCheckInterval = null;
    }
  }

  checkStripeVerification = async () => {
    if (!global.user.stripeId) return;
    
    this.setState({ checkingVerification: true });
    
    try {
      const r = await fetch('https://us-central1-eonn-teletech.cloudfunctions.net/getStripeAccountStatus', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ accountId: global.user.stripeId, testing: global.user.t_testing }),
      });
      const status = await r.json();

      console.log("T_Home verification check status:", status);
      
      global.user.stripeLinked = status.ready;
      global.user.stripeStatus = {
        ready: status.ready,
        charges_enabled: status.charges_enabled,
        payouts_enabled: status.payouts_enabled,
        details_submitted: status.details_submitted,
        currently_due: status.currently_due,
        past_due: status.past_due,
        disabled_reason: status.disabled_reason
      };

      if (status.ready) {
        // Account is now verified - stop polling and update Firebase
        this.stopVerificationPolling();
        await FirebaseUsers.updateUserInfo();
      } else if (status.disabled_reason === 'requirements.pending_verification') {
        // Still pending - start polling if not already running
        if (!this.verificationCheckInterval) {
          this.startVerificationPolling();
        }
      } else {
        // Some other issue - stop polling
        this.stopVerificationPolling();
      }
      
      this.setState({ checkingVerification: false });
    } catch (error) {
      console.log("Error checking stripe verification:", error);
      this.setState({ checkingVerification: false });
    }
  }

  getStripeStatusMessage = () => {
    if (!global.user.stripeStatus) return null;
    
    const { disabled_reason, currently_due, past_due } = global.user.stripeStatus;
    
    if (disabled_reason === 'requirements.pending_verification') {
      return {
        title: 'Account Verification in Progress',
        message: 'We\'re verifying your account information with Stripe. This usually takes a few minutes but can take up to 24 hours.',
        type: 'pending'
      };
    }
    
    if (disabled_reason === 'requirements.past_due') {
      return {
        title: 'Additional Information Required',
        message: 'Your account requires additional verification information. Please complete your Stripe setup.',
        type: 'action_required'
      };
    }
    
    if (disabled_reason === 'rejected.fraud') {
      return {
        title: 'Account Verification Issue',
        message: 'Your account was flagged for suspected fraud. Please contact support for assistance.',
        type: 'error'
      };
    }
    
    if (disabled_reason === 'rejected.incomplete_verification') {
      return {
        title: 'Verification Incomplete',
        message: 'Your account verification was incomplete. Please retry the setup process.',
        type: 'action_required'
      };
    }
    
    if (disabled_reason === 'rejected.listed') {
      return {
        title: 'Account Verification Issue',
        message: 'Your account cannot be verified due to regulatory restrictions. Please contact support.',
        type: 'error'
      };
    }
    
    if (disabled_reason === 'rejected.terms_of_service') {
      return {
        title: 'Terms of Service Issue',
        message: 'Your account was rejected due to terms of service violations. Please contact support.',
        type: 'error'
      };
    }
    
    if (disabled_reason === 'under_review') {
      return {
        title: 'Account Under Review',
        message: 'Your account is currently under review by Stripe. This process can take several business days.',
        type: 'pending'
      };
    }
    
    if (currently_due && currently_due.length > 0) {
      return {
        title: 'Additional Information Required',
        message: 'Your account setup is incomplete. Please finish providing the required information.',
        type: 'action_required'
      };
    }
    
    if (disabled_reason) {
      return {
        title: 'Account Setup Issue',
        message: 'There\'s an issue with your account setup. Please contact support for assistance.',
        type: 'error'
      };
    }
    
    return null;
  }

  updateIssues = (issues) => {
    console.log("issues", issues);
    //console.log(consult);
    /*this.setState(prevState => ({
      issues: [...prevState.issues, consult]
    }))*/
    this.setState({issues:issues});
  }

  getFullTechUrl = () => {
    const baseUrl = 'https://consult.autoteletech.com/';
    let slug = '';
    try {
      slug = global.user && global.user.techLink ? decodeURIComponent(global.user.techLink) : '';
    } catch (e) {
      slug = global.user && global.user.techLink ? String(global.user.techLink) : '';
    }
    const encodedSlug = encodeURIComponent((slug || '').trim());
    return baseUrl + encodedSlug;
  }

  copyTechUrl = async () => {
    try {
      const url = this.getFullTechUrl();
      await Clipboard.setStringAsync(url);
      this.setState({ copied: true });
      setTimeout(() => this.setState({ copied: false }), 1500);
    } catch (error) {
      Alert.alert('Error', 'Failed to copy URL');
    }
  }

  renderAccountStatus = () => {
    const statusInfo = this.getStripeStatusMessage();
    
    if (!statusInfo) {
      return null;
    }

    // Determine styles based on status type
    let accentStyle = [styles.statusAccent];
    let contentStyle = [styles.statusContent];
    let buttonStyle = [styles.retryButton];
    
    if (statusInfo.type === 'pending') {
      accentStyle.push(styles.statusPendingAccent);
      contentStyle.push(styles.statusPending);
      buttonStyle.push(styles.retryButtonPending);
    } else if (statusInfo.type === 'action_required') {
      accentStyle.push(styles.statusActionRequiredAccent);
      contentStyle.push(styles.statusActionRequired);
      buttonStyle.push(styles.retryButtonAction);
    } else if (statusInfo.type === 'error') {
      accentStyle.push(styles.statusErrorAccent);
      contentStyle.push(styles.statusError);
      buttonStyle.push(styles.retryButtonAction);
    }

    return (
      <View style={styles.statusContainer}>
        {/* Red accent bar on left (matching EonnTitle) */}
        <View style={accentStyle} />
        
        {/* Main content area with dark background */}
        <View style={contentStyle}>
          <Text style={styles.statusTitle}>{statusInfo.title}</Text>
          <Text style={styles.statusMessage}>{statusInfo.message}</Text>
          
          {statusInfo.type === 'pending' && this.state.checkingVerification && (
            <View style={{ flexDirection: 'row', alignItems: 'center', marginTop: 8 }}>
              <ActivityIndicator size="small" color="#ffffff" style={{ marginRight: 8 }} />
              <Text style={[styles.statusMessage, { fontSize: 14, marginBottom: 0, opacity: 0.8 }]}>
                Checking status...
              </Text>
            </View>
          )}
          
          {statusInfo.type === 'action_required' && (
            <View style={styles.retryButtonWrapper}>
              <TouchableHighlight
                style={buttonStyle}
                onPress={() => this.props.navigation.navigate('T_Profile7_Stripe')}
                underlayColor="#d85a4a"
              >
                <Text style={styles.retryButtonText}>
                  Complete Setup
                </Text>
              </TouchableHighlight>
            </View>
          )}
          
          {statusInfo.type === 'pending' && (
            <View style={styles.retryButtonWrapper}>
              <TouchableHighlight
                style={buttonStyle}
                onPress={() => this.checkStripeVerification()}
                underlayColor="#d85a4a"
                disabled={this.state.checkingVerification}
              >
                <Text style={styles.retryButtonText}>
                  {this.state.checkingVerification ? 'Checking...' : 'Check Status'}
                </Text>
              </TouchableHighlight>
            </View>
          )}
        </View>
      </View>
    );
  }

  render() {
    return (
      <ScrollView style={mstyles.sContainer} contentContainerStyle={mstyles.sContent}>

        {/* TEMPORARY: test shortcut to the job request screen (remove with components/test_request_button.js) */}
        <TestRequestButton navigation={this.props.navigation} style={{ marginTop: 0 }} />
        
        {/* Earnings summary + Stripe setup CTA */}
        <View style={{ width: '100%', padding: 20, backgroundColor: '#202025', borderRadius: 8, marginBottom: 20 }}>
          <Text style={[mstyles.mfont, { color: '#fff', fontSize: 16, marginBottom: 8 }]}>
            Earnings Overview
          </Text>
          <View style={{ flexDirection: 'row', justifyContent: 'space-between' }}>
            <View>
              <Text style={[mstyles.mfont, { color: '#bbb', fontSize: 13 }]}>Total earned</Text>
              <Text style={[mstyles.mfont, { color: '#fff', fontSize: 22, fontWeight: 'bold' }]}>
                {this.state.earningsLoading ? '—' : `$${(this.state.earningsLifetime || 0).toFixed(2)}`}
              </Text>
            </View>
            <View>
              <Text style={[mstyles.mfont, { color: '#bbb', fontSize: 13, textAlign: 'right' }]}>Pending to withdraw</Text>
              <Text style={[mstyles.mfont, { color: '#fff', fontSize: 22, fontWeight: 'bold', textAlign: 'right' }]}>
                {this.state.earningsLoading ? '—' : `$${(this.state.earningsPending || 0).toFixed(2)}`}
              </Text>
            </View>
          </View>
          {!global.user.stripeLinked &&
            <View style={{ marginTop: 16 }}>
              <EonnButton2
                navigationProps={this.props.navigation}
                image={require('../assets/images/button1.png')}
                style={{ marginBottom: 0, borderWidth: 2, borderColor: '#757c91', borderRadius: 70, marginTop: 5, marginLeft: 'auto', marginRight: 'auto' }}
                paddingOffset={17}
                lines={[
                  { text: 'SET UP STRIPE', size: 20 },
                  { text: 'TO WITHDRAW YOUR EARNINGS', size: 13 },
                ]}
                screen={'T_Profile6b'}
              />
            </View>
          }
        </View>

        {/* <EonnButton
          onPress={() => {
            global.consult = {
              id: common.randomID(),
              c_name: "Jeremy Hamilton",
              c_vehicle: "2016 Honda Civic",
              c_miles: "87,000",
              channel: "test1",
              desc: "Engine fails to start",
              media: [
                "https://via.placeholder.com/400x300/cccccc/666666?text=Test+Image+1",
                "https://via.placeholder.com/400x300/bbbbbb/555555?text=Test+Image+2"
              ],
              timeRequested: new Date().toISOString(),
              note: "My car keeps dying on me while driving and when it dies, all the lights on my dash comes up and it won't start after several cranks. I need to know what could be wrong, and estimated cost to fix it.",
              token: "007eJxTYHCTKFi94cjdkHp5rc8HU2z3OW9etIP/qPPx780HvV8KsN5VYDA3T0tOMzAztjRITDZJTjSzME1LTDZPNEoyNk8zTrQwPPmUP6UhkJHB5Uo4EyMDBIL4rAwlqcUlhgwMAMr7IRo=",
            };
            global.user.uid = "test";
            //FirebaseConsult.updateConsultInfo();
            this.props.navigation.navigate('T_Consult1');
          }}
          >
        Test2</EonnButton> */}
        
        {!global.user.stripeLinked && this.renderAccountStatus()}

        {this.state.err
          ? <Text style={mstyles.err}>{this.state.err}</Text>
          : null
        }

        {/* My Customer Requests - issues with techLink */}
        <EonnTitle style={{marginBottom:0, fontSize:21, lineHeight:28 }}>My Customer Requests</EonnTitle>
        {/* Share link row */}
        <View style={styles.issueButton}>
          <View style={styles.issueButton2}>
            <View style={{flex:1}}>
              <Text style={[mstyles.mfont,styles.issueName]}>Share Video Consultation Link</Text>
              <Text style={[mstyles.mfont,{ fontSize: 13, color: '#6b6b6b' }]} numberOfLines={1}>
                {this.getFullTechUrl()}
              </Text>
            </View>
            <TouchableHighlight
              onPress={this.copyTechUrl}
              style={{ backgroundColor: '#e96556', borderRadius: 6, paddingVertical: 8, paddingHorizontal: 12 }}
              underlayColor={'#d85a4a'}
            >
              <Text style={{ color: '#fff', fontSize: 13, fontFamily: 'nunito', fontWeight: 'bold' }}>
                {this.state.copied ? 'COPIED' : 'COPY'}
              </Text>
            </TouchableHighlight>
          </View>
        </View>
        {this.state.issues.filter(issue => issue.techLink && issue.techLink !== null).length > 0
          ? this.state.issues
              .filter(issue => issue.techLink && issue.techLink !== null)
              .sort((a, b) => new Date(b.timeRequested) - new Date(a.timeRequested))
              .map((issue, i) =>
              <TouchableHighlight
                key={`my-${i}`}
                onPress={() => {
                  global.consult = issue;
                  this.props.navigation.navigate('T_Request1');
                }}
                style={styles.issueButton}
                underlayColor={'#e6e6eb'}
              >
                <View style={styles.issueButton2}>
                  <View style={{flex:1}}>
                    <Text style={[mstyles.mfont,styles.issueName]}>{( common.timeDifference(issue.timeRequested) )}</Text>
                    <Text style={[mstyles.mfont,styles.issueTitle]}>{issue.desc}</Text>
                    <Text style={[mstyles.mfont,styles.issueVehicle]}>{issue.c_vehicle}</Text>
                  </View>
                  <Image source={require('../assets/images/arrow1.png')} style={styles.profileArrow} />
                </View>
              </TouchableHighlight>
            )
          : <View style={styles.waitingBox}>
              <Text style={[mstyles.mfont,styles.waitingText]}>No customer requests
              <EonnEllipsis style={[mstyles.mfont,styles.waitingText]}/></Text>
            </View>
        }

        {/* Marketplace Requests - issues with null techLink */}
        {global.user.verified &&
          <>
            <EonnTitle style={{marginBottom:0, marginTop:30, fontSize:21, lineHeight:28 }}>Marketplace Requests</EonnTitle>
            {this.state.issues.filter(issue => !issue.techLink || issue.techLink === null).length > 0
              ? this.state.issues
                  .filter(issue => !issue.techLink || issue.techLink === null)
                  .sort((a, b) => new Date(b.timeRequested) - new Date(a.timeRequested))
                  .map((issue, i) =>
                  <TouchableHighlight
                    key={`marketplace-${i}`}
                    onPress={() => {
                      global.consult = issue;
                      this.props.navigation.navigate('T_Request1');
                    }}
                    style={styles.issueButton}
                    underlayColor={'#e6e6eb'}
                  >
                    <View style={styles.issueButton2}>
                      <View style={{flex:1}}>
                        <Text style={[mstyles.mfont,styles.issueName]}>{( common.timeDifference(issue.timeRequested) )}</Text>
                        <Text style={[mstyles.mfont,styles.issueTitle]}>{issue.desc}</Text>
                        <Text style={[mstyles.mfont,styles.issueVehicle]}>{issue.c_vehicle}</Text>
                      </View>
                      <Image source={require('../assets/images/arrow1.png')} style={styles.profileArrow} />
                    </View>
                  </TouchableHighlight>
                )
              : <View style={styles.waitingBox}>
                  <Text style={[mstyles.mfont,styles.waitingText]}>No marketplace requests
                  <EonnEllipsis style={[mstyles.mfont,styles.waitingText]}/></Text>
                </View>
            }
          </>
        }
      </ScrollView>
    );
  }
}